import React, { useEffect, useState, useContext } from 'react';
import { 
    Row, 
    Col, 
    Select, 
    Divider, 
    Button, 
    DatePicker, 
    Space, 
    Form, 
    Input, 
    Typography, 
    Collapse, 
    message, 
    Upload, 
    Modal, 
    Image, 
    List, 
    Spin, 
    Tooltip, 
    InputNumber, 
    Badge, 
    Comment, 
    Descriptions 
} from 'antd';
import AppContext from "../AppContext"
import moment from 'moment';
import "antd/dist/antd.css";
import "../../css/chat.css";
import { onCreateClaim, onGetClaimByUserid, onUpdateClaim, onGetClaimByLimit  } from '../../Controller/Management/ClaimManagement';
import { onCreateChat, onGetChat, onCreateAttachment } from '../../Controller/Chat';
import { PictureOutlined, SendOutlined, ReloadOutlined, FileOutlined, PlusOutlined } from "@ant-design/icons";
import { printToPreview } from '../../Controller/FilePreview';
import { GetTranslation } from '../../Models/shared/general';
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import T_Error from "../404";

const { Panel }                     = Collapse;
const { Text, Paragraph }           = Typography;
const { TextArea }                  = Input;
const { Option }                    = Select;

export default function ClaimManagement(prop){
    //===== VARIABLE ====
    const global                            = useContext(AppContext)
    const userid                            = global.UserIdentity.userid;
    const [form]                            = Form.useForm();
    const [textform]                        = Form.useForm();
    const [datasource, setDataSource]       = useState([]);
    const [newDatasource, setNewDatasource] = useState([]);
    const [chatlist, setChatList]           = useState([]);
    const [filelist, setFileList]           = useState([]);

    const [btndisable, setBtnDisable]       = useState(false);
    const [isMaintenance, setIsMaintenance] = useState(false);      // Used for maintenance
    //======== IMAGE ========
    const [previewIconVisible, setPreviewIconVisible]   = useState(false);
    const [previewIconImage, setPreviewIconImage]       = useState('');

    //======= COUNT ========
    const count                             = 5;
    const [newIndex, setnewindex]           = useState(1);
    
    //===== PERSON IN CHARGE ======
    const [isInCharge, setIncharge]         = useState(-1);
    const [userLists, setUserLists]         = useState([]);

    //===== STATUS ========
    const [dataStatus, setDataStatus]       = useState(-1);

    //==== REFERENCE NO ======
    const [refNo, setRefNo]                 = useState("");

    //===== DROPDOWN =======
    const [status, setStatus]               = useState(-1);
    const [searchUser, setSearchUser]       = useState("");

    //===== FILTERED DATA =======
    const [date, setDate]                   = useState("");
    const [period, setPeriod]               = useState(undefined);

    //====== COLLAPSE ======
    const [collapse, setCollapse]           = useState([]); // SET IS COLLAPSE

    //====== CHAT =======
    const [chatdata, setChatData]               = useState([]);
    const [chatmsg, setChatmsg]                 = useState("");
    const [chatinitLoading, setchatInitLoading] = useState(true);
    const [chatloading, setChatLoading]         = useState(false);

    // ===== LIST ======
    const [initLoading, setInitLoading]     = useState(true);
    const [loading, setLoading]             = useState(false);

    //====== TOTAL =======
    const [totalAmt, setTotalAmt]           = useState(0);

    //====== DISABLED ======
    const [datedisable, setdatedisable]     = useState(false);
    const [perioddisable, setperioddisable] = useState(false);

    //======= MODAL ========
    const [modalVisible, setModalVisible]               = useState(false);
    const [listdata, setlistdata]                       = useState({}); // status data
    const [confirmModalVisible, setConfirmModalVisible] = useState(false);
    const userlang                                      = navigator.language || navigator.userLanguage;
    //============== DROPDOWN OPTIONS ============== 
    //const userlist      = ["nicholas", "max", "elyn", "waibein","bee", "melvin","root"];
    const userlist      = ["60ebde816d150ba31d16a879", "60ebf1bbaebe39153046d6d2", "60f11782c8ab5e5708c10f8b", "60ebf1d6aebe39153046d6d6","60ebf3b2e0741b107ce0d8a6","62047aa56682f16a41f11860", "root"];
    const statuslist    = [{ key: 0, value: "Pending" }, {  key: 9, value : "Reject", }, { key: 1, value: "Approve"}, { key: 2, value : "Verified" }];

    //===== USE EFFECT ========
    useEffect(() => {
        //------ INITIALIZE ------
        onGetUserLists({});
        let isUser  = userlist.filter(x => x == userid).length;
        setDate(moment());
        setIncharge(isUser);
    },[]);

    //====== USER FILTER =======
    useEffect(() => {
        if(isInCharge != -1){
            onRefresh({
                index       : 1,
                searchUser  : searchUser
            });
        }
    }, [status, isInCharge, date, period]);

    //===== FUNCTION =====
    const onRefresh = (data) => {
        let { isSearch = 0, searchUser = '', index = 1 }  = data;
        //======= FOR MANAGEMENT ==========
        if(isInCharge > 0 && searchUser == ""){
            //===== STATUS IS ALL ======
            if(status == -1){
                let plen,rlen,alen,vlen;

                //====== IF IS SEARCH NAME ========
                if(isSearch == 1){
                    plen = 1; 
                    rlen = 1; 
                    alen = 1;
                    vlen = 1;
                }
                else{
                    plen = datasource.filter(x => x.status == statuslist[0].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[0].key).length + 1;
                    rlen = datasource.filter(x => x.status == statuslist[1].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[1].key).length + 1;
                    alen = datasource.filter(x => x.status == statuslist[2].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[2].key).length + 1;
                    vlen = datasource.filter(x => x.status == statuslist[3].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[3].key).length + 1;
                }

                return Promise.all([
                    onGetClaimByLimit({ index : plen, status: statuslist[0].key}),
                    onGetClaimByLimit({ index : rlen, status: statuslist[1].key}),
                    onGetClaimByLimit({ index : alen, status: statuslist[2].key}),
                    onGetClaimByLimit({ index : vlen, status: statuslist[3].key})
                ])
                .then(([res1, res2, res3, res4]) => {
                    let newds   = isSearch == 1 ? [] : datasource;
                    newds       = onCheckExist(res1.data, newds);
                    newds       = onCheckExist(res2.data, newds);
                    newds       = onCheckExist(res3.data, newds);
                    newds       = onCheckExist(res4.data, newds);

                    setDataSource(newds);
                    onRefreshNewDatasource(newds, searchUser);
                    //=== INIT TASK LOADING ===
                    setInitLoading(false);
                    return;
                })               
                .catch(err => {
                    message.error("Cannot get data");
                    setIsMaintenance(true);
                });
            }
            else{
                onGetClaimByLimit({
                    index   : index,
                    status  : status
                })
                .then(val => {
                    let newds   = isSearch == 1 ? val.data : datasource;
                    newds       = onCheckExist(val.data, newds);
                    setDataSource(newds);
                    onRefreshNewDatasource(newds, searchUser);
                    //=== INIT TASK LOADING ===
                    setInitLoading(false);
                    return val;
                })            
                .catch(err => {
                    message.error("Cannot get data");
                    setIsMaintenance(true);
                });
            }
        }
        //======= PERSON CLAIM VIEW ==========
        else{                                   
            //===== STATUS IS ALL ======
            if(status == -1){
                let plen,rlen,alen,vlen;

                //====== IF IS SEARCH NAME ========
                if(isSearch == 1){
                    plen = 1; 
                    rlen = 1; 
                    alen = 1;
                    vlen = 1;
                }
                else{
                    plen = datasource.filter(x => x.status == statuslist[0].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[0].key).length + 1;
                    rlen = datasource.filter(x => x.status == statuslist[1].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[1].key).length + 1;
                    alen = datasource.filter(x => x.status == statuslist[2].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[2].key).length + 1;
                    vlen = datasource.filter(x => x.status == statuslist[3].key).length == 0 ? index : datasource.filter(x => x.status == statuslist[3].key).length + 1;
                }

                //========= IF ALL GET ALL STATUS =========
                return Promise.all([
                    onGetClaimByUserid({ index : plen, userid  : searchUser == "" ? userid : searchUser, status: statuslist[0].key}),
                    onGetClaimByUserid({ index : rlen, userid  : searchUser == "" ? userid : searchUser, status: statuslist[1].key}),
                    onGetClaimByUserid({ index : alen, userid  : searchUser == "" ? userid : searchUser, status: statuslist[2].key}),
                    onGetClaimByUserid({ index : vlen, userid  : searchUser == "" ? userid : searchUser, status: statuslist[3].key})
                ])
                .then(([res1, res2, res3, res4]) => {
                    let newds   = isSearch == 1 ? [] : datasource;
                    newds       = onCheckExist(res1.data, newds);
                    newds       = onCheckExist(res2.data, newds);
                    newds       = onCheckExist(res3.data, newds);
                    newds       = onCheckExist(res4.data, newds);

                    setDataSource(newds);
                    onRefreshNewDatasource(newds, searchUser);
                    //=== INIT TASK LOADING ===
                    setInitLoading(false);
                    return;
                })               
                .catch(err => {
                    message.error("Cannot get data");
                    setIsMaintenance(true);
                });
            }
            else{
                onGetClaimByUserid( {
                    index   : index,
                    userid  : searchUser == "" ? userid : searchUser,    // To get user if has search user
                    status  : status
                })
                .then(val => {
                    let newds   = isSearch == 1 ? val.data : datasource;
                    newds       = onCheckExist(val.data, newds);
                    setDataSource(newds);
                    onRefreshNewDatasource(newds, searchUser);
                    //=== INIT TASK LOADING ===
                    setInitLoading(false);
                    return val;
                })
                .catch(err => {
                    message.error("Cannot get data");
                    setIsMaintenance(true);
                })
            }
        }
    }

    const onRefreshNewDatasource = (data, searchUser) => {
        if(data != undefined && data != "" ){
            var table       = data;
            table           = onStatusLoad(status, table);

            //===== USER FILTER ========
            if(searchUser && searchUser != ""){
                //====== USER FILTER ========
                table  = table.filter(x => x.userid == searchUser);
            }
            
            //======= DATE FILTER ========
            var firstDate = "", lastDate = "", fromDate = "";
            let newDate     =  moment().format("YYYY-MM-10");
            if(date && date != ""){
                newDate         = date.format("YYYY-MM");
                var year        = newDate.substring(0,4);
                var month       = newDate.substring(5,7);
                fromDate        = new Date(year, month, 0);

                firstDate       = moment(fromDate, 'DD/MM/YYYY').startOf('month');
                lastDate        = moment(fromDate, 'DD/MM/YYYY').endOf('month');

                table           = table.filter(x => moment.unix(x.createdte) >= firstDate && moment.unix(x.createdte) <= lastDate);
            }

            //===== PERIOD FILTER ========
            if(period){
                switch(period){
                    case "1st":
                        if(date && date != ""){
                            firstDate   = moment(fromDate, 'DD/MM/YYYY').startOf('month');
                            lastDate    = moment(fromDate, 'DD/MM/YYYY').startOf('month').add(14, "days");
                            table       = table.filter(x => moment.unix(x.createdte) >= firstDate && moment.unix(x.createdte) <= lastDate);
                        }
                        else{
                            table       = table.filter(x => moment.unix(x.createdte) <=  moment(newDate));
                        }
                        break;
                    case "2nd":
                        //==== IF GOT DATE ====
                        if(date != ""){
                            firstDate   = moment(fromDate, 'DD/MM/YYYY').startOf('month').add(14, "days");
                            lastDate    = moment(fromDate, 'DD/MM/YYYY').endOf('month');
                            table       = table.filter(x => moment.unix(x.createdte) >= firstDate && moment.unix(x.createdte) <= lastDate);
                        }
                        //==== NO DATE ====
                        else{
                            table       = table.filter(x => moment.unix(x.createdte) >  moment(newDate));
                        }
                        break;
                }
            }

            // if(period && date){
            //     let newDate     = date.format("YYYY-MM");
            //     let year        = newDate.substring(0,4);
            //     let month       = newDate.substring(5,7);
            //     let fromDate    = new Date(year, month, 0);
            //     let firstDate, lastDate;

            //     switch(period){
            //         case "1st":
            //             firstDate   = moment(fromDate, 'DD/MM/YYYY').startOf('month');
            //             lastDate    = moment(fromDate, 'DD/MM/YYYY').startOf('month').add(14, "days");
            //             table       = table.filter(x => moment.unix(x.createdte) >= firstDate && moment.unix(x.createdte) <= lastDate);
            //             break;
            //         case "2nd":
            //             firstDate   = moment(fromDate, 'DD/MM/YYYY').startOf('month').add(14, "days");
            //             lastDate    = moment(fromDate, 'DD/MM/YYYY').endOf('month');
            //             table       = table.filter(x => moment.unix(x.createdte) >= firstDate && moment.unix(x.createdte) <= lastDate);
            //             break;
            //     }
            // }

            //===== DATE ==========
            setNewDatasource(table);
            onGetTotal(table);
            onSort(table);
            setnewindex(table.length + 1);
        }
        else{
            setNewDatasource(data);
        }
    }

    //====== ON GET USER LISTS ======= 
    const onGetUserLists = (data) => {
        return getAllUserLists(data)
        .then(user => {
            setUserLists(user.data);
        })
        .catch(err => {
            message.error(GetTranslation(userlang, "Cannot get data"));
            setIsMaintenance(true);
        });
    }

    const onCreate = () => {
        //===== TO VALIDATE FORM ITEM ======
        form.validateFields()
        .then(values => {
            setBtnDisable(true);
            let title       = values.title == undefined || values.title.trim() == "" ? values.description.substr(0, 20) : values.title.trim();
            let claimdate   = values.claimdate?.set({"hour": 0, "minute": 0, "seconds": 0}).unix() || "";
            values = { 
                claimtype   : values.claimtype,
                title       : title,
                description : values.description,
                amount      : values.amount,
                claimdate   : claimdate,
                payby       : values.payby,
                refno       : refNo,
                userid      : userid,
                status      : values.claimtype == "requisition" ? 1 : 0
            }

            onCreateAttachment(filelist)
            .then(val => {
                let path            = val.data;
                values.filepath     = path.map(x => x.filepath).toString();

                //===== ON CREATE CLAIM ======
                onCreateClaim(values)
                .then(res => {
                    let newClaimData = datasource;
                    newClaimData.push(res.data);
                    let user = searchUser == "" ? userid : searchUser;
    
                    setDataSource(newClaimData);
                    onRefreshNewDatasource(newClaimData, user);
                    message.success(res.msg);
                    onClear();
                });
            })                
            .catch(err => {
                message.error("Failed to upload attachments");
                setBtnDisable(false);
            });

        });
    }

    //====== LOAD MORE ======
    const onClaimLoadMore = () => {
        onRefresh({ 
            index       : newIndex, 
            isUser      : isInCharge, 
            searchUser  : searchUser
        })
    }

    //20210727 add refresh all windows
    const onReload = () => {
        setBtnDisable(true);
        window.location.reload();
    }

    const onUpdate = (data) => {
        //===== UPDATE DEADLINES ======
        let obj = {};
        const id            = data._id; //MONGO ID DATA

        if(dataStatus != -1){
            // === UPDATE STATUS =======
            const newStatus     = dataStatus;
            obj = {
                claimid     :   id,
                status      :   newStatus
            }
        }

        onUpdateClaim(obj)
        .then(x => {
            setConfirmModalVisible(false);
            let newClaimData    = datasource;
            let _editid         = x.data._id;
            //====== UPDATE THE STATUS INSIDE THE NEW CLAIM DATA ======
            newClaimData.forEach(function(part, index) {
                if(this[index]["_id"] == _editid){
                    this[index]  = x.data;
                    return;
                }
            }, newClaimData);

            setDataSource(newClaimData);
            onRefreshNewDatasource(newClaimData, searchUser);
            setDataStatus(-1);
            message.success(GetTranslation(userlang, "Update successful"));
            return x.data;
        })
        .then(newdata => {     
            onSendMessage(newdata);
        })
        .catch(err => {
            message.error(err);
        })
    }

    const onSendMessage = (data) => {
        //====== CHECK HAS FILE =======
        let claimid     = data._id;
        let from        = userid;
        let to          = userid;
        
        let chat    = { 
            taskid      : claimid,
            from        : from,
            to          : to,
            message     : chatmsg
        }

        if(chatmsg != "" && filelist.length == 0){
            setBtnDisable(true);
            //==== IF GOT CHAT AND WITHOUT FILE ======
            onCreateChat(chat)
            .then(x => {
                setBtnDisable(false);
                //==== REFRESH CHAT ======
                onGetChat({ taskid: claimid })
                .then(val => {
                    onClear();
                    setLoading(false);
                    setInitLoading(false);
                    setChatData(val.data);
                    onGetChatData(val.data, false); 
                    return;
                })
                .catch(err => {
                    return err;
                })
            })
        }
        else{
            //===== IF GOT FILE ======
            if(filelist.length > 0){
                setBtnDisable(true);
                // const filename  =   filelist[0].originFileObj;
                onCreateAttachment(filelist)
                .then(response => {
                    let path            = response.data;
                    chat.filepath       = path.map(x => x.filepath).toString();

                    //==== VALIDATION =======
                    onCreateChat(chat)
                    .then(x => {
                        setBtnDisable(false);
                        //==== REFRESH CHAT ======
                        onGetChat({ taskid: claimid })
                        .then(val => {
                            onClear();
                            setChatData(val.data);
                            onGetChatData(val.data, false); 
                            return;
                        })
                        .catch(err => {
                            return err;
                        })
                    });

                })                
                .catch(err => {
                    message.error("Failed to upload attachments");
                    setBtnDisable(false);
                });
            }
        }
    }

    const onSearch = (val) => {
        setStatus(val);
    }

    const onCollapseChange = (val) => {
        setCollapse(val)
        if(val != undefined){
            return onGetChat({ taskid: val })
            .then(val => {
                setChatData(val.data);
                setchatInitLoading(false);
                onGetChatData(val.data, false)
                return;
            })
            .catch(err => {
                return err;
            })
        }

    }
    
    const onClear = () => {
        setModalVisible(false);
        form.resetFields();
        setFileList([]);
        setChatmsg("");
        setBtnDisable(false);
        textform.resetFields();
    }

    //====== LOAD MORE BUTTON =======
    const loadMore = !initLoading && !loading ? (
        <div
            style={{
                textAlign: 'center',
                marginTop: 12,
                height: 32,
                lineHeight: '32px',
            }}
        >
            <Button onClick={onClaimLoadMore}>{GetTranslation(userlang, "Load More")}</Button>
        </div>
    ): null;

    const chatLoadMore = !initLoading && !chatloading ? (
        <div
            style={{
                textAlign: 'center',
                marginTop: 12,
                height: 32,
                lineHeight: '32px',
            }}
        >
            <Button onClick={() => { onGetChatData(chatdata , true) }}>{GetTranslation(userlang, "Load More")}</Button>
        </div>
    ): null;

    //===== GET TOTAL =====
    const onGetTotal = (data) => {
        let totalamt = 0, newstatus = '';
        for(var i = 0;  i < data.length; i++){
            newstatus  = data[i].status; 
            let amount  = data[i].amount || 0;
            // 20210920 ===== DONT COUNT IF REJECT =====
            if(status != 9 && newstatus == 9){}
            else{
                totalamt += amount;
            }
        }

        totalamt = totalamt <= 0 ? 0 : totalamt;
        setTotalAmt(Number(totalamt).toFixed(2));
    }

    //====== GET CHAT DATA =======
     const onGetChatData = (data, isloading) => {
        if(isloading){
            //=== IF LIST LENGTH IS SAME WITH DATA LENGTH =====
            if(chatlist.length == data.length){
                setChatLoading(true);
            }

            //===== IF PRESS LOAD MORE =======
            let array       = chatlist;
            let array1      = data.slice(chatlist.length, chatlist.length + count);
            setChatList(array.concat(array1));
        }
        else{
            //==== IF NOT PRESS LOAD MORE ======
            if(data.length < count){
                setChatLoading(true)
            }
            else{
                setChatLoading(false);
            }

            setChatList(data.slice(0, count));
        }
    }

    //======= LIST  ========
    //====== PANEL HEADER ======
    const panelHeader = (data) => {
        let claimdate   = `${moment.unix(data.claimdate).format("DD/M ddd")}`;
        let title       = `${data.claimtype} at - ${claimdate} - ${data.title}`;
       
        let tempusername = userLists.filter(x => x._id == data.userid)
       
        if(tempusername == undefined || tempusername.length == 0 )
        {
            tempusername = data.userid
        }
        else
        {
            tempusername = tempusername[0].userid
        }
        let user        = `Name: ${tempusername}`

        const ele       = React.createElement("small",{style: {fontSize: "9px", display:"block" }}, title);
        const ele1      = React.createElement("small", null, `Claim At: ${moment.unix(data.createdte).format("DD/M")}`);
        const ele2      = React.createElement("small",{style: {fontSize: "9px", display:"block" }}, user);
        if(isInCharge){
            const master    = React.createElement("div", {style: {display: "inline-block", fontWeight:"bold"}}, null , [ele1, ele, ele2]);
            return master;
        }
        else{
            const master    = React.createElement("div", {style: {display: "inline-block", fontWeight:"bold"}}, null , [ele1, ele]);
            return master;
        }
    }

    const renderClaimItem = (item) => {
        return (
            <Collapse 
                expandIconPosition={'right'} 
                accordion
                activeKey={collapse}
                onChange={onCollapseChange}
            >
                <Panel header={panelHeader(item)} key={item._id} extra={genExtra(item)}>
                    <div></div>    
                    <div>
                        <Paragraph className="textparagraph">{item.description}</Paragraph>
                    </div>
                    <div>Amount: {item.amount}</div>   
                    <br />
                    <div>Ref No: {item.refno}</div>   
                    <br />
                    <div>
                        {showAttachmentList(item)}
                    </div>
                    <br />
                    {/* ======  BUTTON  ====== */}
                    <div style={{ display:"flex", margin:"10 0", float:"right" }}>
                        {/* APPROVE */}
                        {approveBtn(item)}
                        {/* VERIFY */}
                        {verifyBtn(item)}
                        {/* REJECT */}
                        {rejectBtn(item)}
                    </div>
                    <br />
                    <Divider style={{marginBottom:"5px"}}></Divider>
                    {/* MESSAGE BOX */}
                    <div style={{display:"flex", position: "relative"}}>
                        <div style={{width: "70%"}}>
                            <Form form={textform}>
                                <Form.Item name="chatmsg">
                                    <TextArea autoSize={{ minRows: 1, maxRows: 6 }} onChange={(e) => setChatmsg(e.target.value)} />
                                </Form.Item>
                            </Form>
                        </div>
                        <div style={{width: "10%", display:"flex"}}>
                            <Upload {...commentFileProps } ><Button><PictureOutlined /></Button></Upload>
                            <Button disabled={btndisable} onClick={() => onSendMessage(item)}>
                                { btndisable ? <Spin /> : <SendOutlined /> }
                            </Button>
                        </div>
                    </div>
                    <div>
                        <Upload {...hiddenfileProps} ><Button hidden><PictureOutlined /></Button></Upload>
                    </div>
                    {/* MESSAGES */}
                    {onChatForm()}
                </Panel>
            </Collapse>
        )
    }

    const genExtra = (data) => {
        return (
            <>
                {(() => {
                    switch(data.status){
                        case 1:
                            //====== COMPLETED =======
                            return (
                                <>
                                    <div style={{ textAlign:"right" }}>
                                        {Number(data.amount).toFixed(2)}
                                    </div> 
                                    <Badge status="success" text="Approved" />
                                </>
                            )
                        case 9:
                            //==== REJECTED ======
                            return (
                                <>
                                    <div style={{ textAlign:"right" }}>
                                        {Number(data.amount).toFixed(2)}
                                    </div> 
                                    <Badge status="error" text="Rejected" />
                                </>
                            )
                        case 0:
                            //===== PENDING =======
                            return (
                                <>
                                    <div style={{ textAlign:"right" }}>
                                        {Number(data.amount).toFixed(2)}
                                    </div> 
                                    <Badge status="processing" text="Pending" />
                                </>
                            )
                        case 2:
                            //====== VERIFIED ======
                            return (
                                <>                                    
                                    <div style={{ textAlign:"right" }}>
                                        {Number(data.amount).toFixed(2)}
                                    </div> 
                                    <Badge status="warning" text="Verified" />
                                </>
                            )
                    }
                })()}
            </>
        )
    }

    //====== CHAT ========
    const chatRenderItem = (item) => {
        return (
            <List.Item>
                <Comment
                    className={item.from == userid ? "itemRight" : "itemLeft" }
                    style={{width:"100%"}}
                    author={item.from}
                    datetime={
                        <>
                            <Tooltip title={moment.unix(item.createdte).format("DD/M ddd h:mm a") ?? ""}>
                                {moment.unix(item.createdte).subtract(1, 'days').fromNow()}
                            </Tooltip>
                        </>
                    }
                    content={
                        <div style={{marginBottom:"2px" }}>
                            <div>
                                <Text className="textparagraph">{item.message}</Text>
                            </div>
                            {showAttachmentList(item)}
                        </div>
                    }
                >
                </Comment>
            </List.Item>
        )
    }

    //====== ATTACHMENT ======
    const showAttachmentList = (item) => {
        if(item.filepath != undefined && item.filepath != ""){
            return item.filepath.split(',').map(filepath => {
                var ext = filepath.split('.').pop();
                let img = ["png", "jpeg", "jpg"];
                if(img.filter(x => x == ext).length > 0){
                    return ( 
                        <>
                            <Image
                                width   ={200}
                                src     ={`https://qc9sk2.naxgo.online${filepath}`}
                            >
                            </Image>
                        </>
                    )
                }
                else{
                    // ======= OTHER FILE ========
                    let filename    = filepath.split('/');
                    return (
                        <>
                            <div>
                                <FileOutlined /> {filename[filename.length - 1]}
                                <Button style={{marginLeft: "10px"}}>
                                    <a href={`https://qc9sk2.naxgo.online${filepath}`} target="_blank" >
                                        {GetTranslation(userlang, "Open")}
                                    </a>
                                </Button>
                            </div>
                        </>
                    )
                }
            });
        }
        else{
            return (
                <>
                </>
            )
        }
    }

    //====== FORM =======
    // 20210727 FORM CREATE
    const onCreateForm = () => {
        return (
            <div>
                <Form form={form}>
                    {/* CLAIM TYPE */}
                    <Form.Item
                        name="claimtype"
                        rules={[
                            {
                                required: true,
                                message: "Type is required"
                            }
                        ]}
                    >
                        <Select placeholder="Claim Type" showSearch allowClear>
                            <Option value={"payment"}>Payment</Option>
                            <Option value={"requisition"}>Requisition</Option>
                        </Select>
                    </Form.Item>
                    {/* TITLE */}
                    <Form.Item
                        name="title"
                        rules={[
                            {
                                required: false,
                                message: "Title is required"
                            }]
                        }>
                        <Input size="large" placeholder="Title" />
                    </Form.Item>
                    {/* DESCRIPTION */}
                    <Form.Item
                        name="description"
                        rules={[
                            {
                                required: true,
                                message: "Description is required"
                            }]
                        }>
                        <TextArea autoSize={{ minRows: 4, maxRows: 6 }} size="large" placeholder="Description" />
                    </Form.Item>
                    {/* ===== AMOUNT ======= */}
                    <Form.Item
                        name="amount"
                        rules={[
                            {
                                required    : true,
                                message     : "Amount is required"
                            }
                        ]}
                    >
                        <InputNumber style={{width: "100%"}} placeholder="Amount" min={1} />
                    </Form.Item>
                    {/* ===== DATE ===== */}
                    <Form.Item
                        name="claimdate"
                        rules={[
                            {
                                required    : true,
                                message     : "Date is required"
                            }
                        ]}
                    >
                        <DatePicker 
                            format="YYYY-MM-DD"
                            placeholder="Payment Date"
                            style={{width: "100%"}}
                        />
                    </Form.Item>
                    {/* ===== PAY BY ====== */}
                    <Form.Item
                        name="payby"
                        rules={[
                            {
                                required    : true,
                                message     : "Pay By is required"
                            }
                        ]}
                    >
                        <Select placeholder="Pay By" showSearch allowClear>
                            <Option value={"company"}>Company</Option>
                            <Option value={"self"}>Self</Option>
                            <Option value={"card"}>Card</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="refNo">
                        <div>
                            <Text>Reference No: {refNo}</Text>
                        </div>
                        <div>
                            <Text type="danger">* Write this number to your receipt number</Text>
                        </div>
                    </Form.Item>
                    {/* ==== ATTACHMENTS ======  */}
                    <Form.Item
                        name="attachment"
                        rules={[
                            {
                                required    : true,
                                message     : "Attachment is required"
                            }
                        ]}
                    >
                        <Upload {...fileProps} ><Button><PictureOutlined /> {GetTranslation(userlang, "Upload")}</Button></Upload>
                    </Form.Item>
                    {/* ===== CREATE BUTTON ===== */}
                    <Form.Item>
                        <div style={{ display: "flex", float: "right" }}>
                            <div style={{ paddingRight: "5px" }}>
                                <Button onClick={onCreate}> { btndisable ? <Spin /> :  `${GetTranslation(userlang, "Create")}`}</Button>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        )
    } 

    const onClaimForm = () => {
        return (
            <>
                <Row justify="start">
                    <Divider>{prop.title ?? "."}</Divider>
                </Row>            
                {/* HEADER */}
                {/* BODY */}
                <Row>
                    <Col span={24}>
                        <div style={{float:"right"}}>
                            <Space size={2}>
                                <Tooltip placement="bottom" title={"New Claim"}>
                                    <Button onClick={(() => { setRefNo(moment().format("YYYYMMDDHms")); setModalVisible(true)})}><PlusOutlined /></Button>
                                </Tooltip>
                                <Button onClick={onReload}>{ btndisable ?  <Spin /> : <ReloadOutlined />}</Button>
                            </Space>
                        </div>

                    </Col>
                </Row>
                {onFilterForm()}
                <Row gutter={[8,8]}>
                    <Col xs={24}>
                        <List {...listProps}></List>
                    </Col>
                </Row>
            </>
        )
    }

    const onFilterForm = () => {
        return (
            <>
                <Row gutter={[8, 8]} style={{ padding: "5px" }}>
                    <Col span={8}>
                        <Select value={status} style={{width: "100%"}} onChange={onStatusChange} onSearch={onSearch} showSearch >
                            {statuslist.map((status, index) => {
                                return (
                                    <Option value={status.key}>{status.value}</Option>
                                )
                            })}
                            <Option value={-1}>All</Option>
                        </Select>
                    </Col>
                    {(() => {
                        if(isInCharge){
                            return (
                                <>
                                    <Col span={8}>
                                        <Select style={{width: "100%"}}  placeholder={"Select user"} onChange={onSearchUser} allowClear showSearch>
                                        {
                                            userLists.map(function(data){
                                                return (
                                                    <Option value={data.userid}>{data.userid}</Option>
                                                )
                                            })
                                        }
                                        </Select>
                                    </Col>
                                </>
                            )
                        }
                    })()}
                    <Col span={8}>
                        <Select style={{width: "100%"}} disabled>
                            <Option value={"oldest"}>Oldest</Option>
                            <Option value={"newest"}>Newest</Option>
                        </Select>
                    </Col>
                </Row>
                {onDateFilter()}  
                <Divider />
                <Descriptions bordered size={"small"} layout={"vertical"}>
                    <Descriptions.Item label="Total Amount">{totalAmt}</Descriptions.Item>
                </Descriptions>
            </>
        )
    }

    const onDateFilter = () => {
        return (
            <Row gutter={[8, 8]} style={{ padding: "5px" }}>
                {/* SELECT DATE */}
                <Col span={8}>
                    <DatePicker {...dateprops}></DatePicker>
                </Col>
                <Col span={8}>
                        {/* <div style={{display:"inline", marginRight: "10px" }}>
                            Filter By:
                        </div> */}
                        <Select {...periodprops}>
                            <Option value={"1st"}>1st period of month</Option>
                            <Option value={"2nd"}>2nd period of month</Option>
                        </Select>
                    </Col>
            </Row>
            
        )
    }

    const onChatForm = () => {
        //====== MARKED WILL CHANGE TO LIST INSTEAD OF CARD =======
        if(chatdata.length > 0){
            return (
                <>                
                    <List {...chatProps}></List>
                </>
            )
        }
        else{
            return (<></>)
        }
    }

    const onCheckExist = (array, list) => {
        if(Object.keys(array).length > 0){
            array.forEach(x => {
                let exist   = list.find(y => y._id == x._id);
                if(exist == undefined || Object.keys(exist).length == 0){
                    list.push(x);
                }
            });
        }

        return list;
    }

    //======= TASK BUTTON ======
    //==== BUTTON CLICK =======
    const onClick = (val, data) => {
        switch(val){
            case "approve":
                setDataStatus(1);
                setConfirmModalVisible(true);
                break;
            case "reject":
                setDataStatus(9);
                setConfirmModalVisible(true);
                break;
            case "verified":
                setDataStatus(2)
                setConfirmModalVisible(true);
                break;
            case "create":
                setDataStatus(0)
                setConfirmModalVisible(true);
                break;
        }

        setlistdata(data);
    }

    //====== APPROVE =======
    const approveBtn = (data) => {
        let style   = "none";

        //====== FOR PERMISSION =======
        if(data.status != 1 && isInCharge && userid != "bee"){
            style = "";
        }

        return (
            <div style={{paddingLeft: "2px"}}>
                <Button onClick = {() => { onClick("approve", data)}} style={{display: style}}>Approve</Button>
            </div>
        )
    }

    //====== REJECT =======
    const rejectBtn = (data) => {
        let style   = "none";

        if(data.status != 9  && isInCharge){
            style = "";
        }

        return (
            <div style={{paddingLeft: "2px"}}>
                <Button type="danger" onClick = {() => { onClick("reject", data)}} style={{display: style}}>Reject</Button>
            </div>
        )

    }

    //======= VERIFY =======
    const verifyBtn = (data) => {
        let style   = "none";

        if(data.status != 2  && isInCharge){
            style = "";
        }

        return (
            <div style={{paddingLeft: "2px"}}>
                <Button onClick={() => { onClick("verified", data)}} style={{ display: style}}>Verify</Button>
            </div>
        )
    }

     //====== MODAL ========    
     const onModal = () => {
        return (
            <Modal 
                title   ={"New Claim"}
                visible ={modalVisible}
                footer  ={null}
                onCancel={handleCancel}
            >{ModalContent()}
            </Modal>
        )
    }

    const handleCancel = () => {
        setModalVisible(false);
        setFileList([]);
        form.resetFields();
    }

    const ModalContent = () => {
        return onCreateForm();
    }

    //========== CONFIRMATION MODAL ===============
    const onConfirmationModal = () => {
        let title   = getModalConfirmationTitle();
        return (
            <Modal
                title   = {title} 
                visible ={confirmModalVisible}
                onOk    ={handleConfirmationOk} 
                onCancel={handleConfirmationCancel}
            >{ModalConfirmationContent()}
            </Modal>
        )
    }

    const handleConfirmationOk = () => {
        //===== UPDATE STATUS ======
        onUpdate(listdata);
    }

    const handleConfirmationCancel = () => {
        setConfirmModalVisible(false);
    }
    //=====================================================

    // TITLE
    const getModalConfirmationTitle = () => {
        let title;
        switch(dataStatus){
            case 9:
                title = "Claim Reject";
                break;
            case 1:
                title = "Claim Approval";
                break;
            case 2:
                title = "Claim Verify";
                break;
        }

        return title;
    }

    const ModalConfirmationContent = () => {
        let act = "";
        //===== STATUS ======
        switch(dataStatus){
            case 9:
                act = "Are you sure you want to reject this claim?";
                break;
            case 1:
                act = "Are you sure you want to approve this claim?";
                break;
            case 2:
                act = "Are you sure you want to verify this claim?";
                break;
            case 0:
                act = "Are you sure you want to create this claim?"
        }

        return (<div>{act}</div>)
    }

    //================= DATE ====================
    const onDateChange = (date) => {
        setDate(date);
    }
    //============================================================

    //================= PERIOD ====================
    const onPeriodChange = (period) => {
        setPeriod(period);
        setdatedisable(false);

        //=== if status is not all, not need reset date ===
        if(status != -1){
            setDate(moment());
        }

        if(period == undefined){
            //=== STATUS STILL IN COMPLETED OR REJECTED ===
            if(status == 0 || status == 2){
                setdatedisable(true);
                setDate("");
            }
        }
        else{
            //=== IF STILL REMAINING PENDING AND VERIFIED ===
            if(status == 0 || status == 2){
                setdatedisable(true);
                setDate("");
            }
        }
    }
    //============================================================

    //====================== STATUS ========================
    // ON LOAD 
    const onStatusLoad = (value, table) => {
        if(value != undefined && value != -1){
            var filteredDS;
            filteredDS  = table.filter(x => x.status == value);
            setNewDatasource(filteredDS);
            return filteredDS;
        }
        else{
            setNewDatasource(table);
            return table;
        }
    }

    const onStatusChange = (data) => {
        setnewindex(1);
        setStatus(data); 
        setdatedisable(false);
        setDate(moment());
        setperioddisable(false);

        if(data == 2 || data == 0){
            //=== PENDING AND VERIFY BASED ON PERIOD ===
            setdatedisable(true);
            setDate("");
        }
        else if(data == 1 || data == 3 || data == 9){
            //=== APPROVED, CLAIMED, REJECTED BASED ON DATE ===
            setperioddisable(true);
            setPeriod(undefined);
        }
    }
    //============================================================

    //========================= USER =============================
   //====== ON USER SEARCH ======
    const onSearchUser = (user) => {
        setSearchUser(user);
        onRefresh({
            index       : 1,
            isSearch    : 1,
            searchUser  : user
        });
    }
    //============================================================


    //===================== IMAGE PREVIEW (FILE) ================================
    const onFileChange = (info) => {
        let newFileList = [...info.fileList];
        if(newFileList && newFileList.length > 0 && newFileList.length >= filelist.length){
            let src = info.url;
            if(!src){
                return new Promise(resolve => {
                    const reader = new FileReader();
                    reader.readAsDataURL(info.file);
                    reader.onload = () => resolve(reader.result);
                }).then(src => {
                    let index   = newFileList.findIndex(x => x.originFileObj == info.file);
                    newFileList[0].preview = src;
                    setFileList(newFileList);
                })
            }
        }
        else{
            setFileList(newFileList)
        }
    }

    const handleIconPreviewCancel = () => {
        setPreviewIconVisible(false)
    }

    const handleIconPreview = (info) => {
        console.log("onUploadChange", info)
        if(info.type.includes("image")){   
            // printToPreview({ b64Data: info.preview, type: info.type })
            setPreviewIconImage(info.preview)
            setPreviewIconVisible(true)
        }
        else{
            printToPreview({ b64Data: info.preview, type: info.type })
        }
    }
    //============================================================

    //==== PROPS ====
    const fileProps = {
        listType    : "picture",
        fileList    : filelist,
        accept      : ".png,.jpeg,.jpg,.pdf",
        multiple    : true,
        beforeUpload: (file) => {    
            return false;
        },
        onChange    : onFileChange,
        onPreview   : handleIconPreview
    };

    const hiddenfileProps = {
        listType    : "picture",
        fileList    : filelist,
        className   : "commentAttachment",
        accept      : ".png,.jpeg,.jpg,.pdf",
        multiple    : true,
        beforeUpload: (file) => {
            return false;
        },
        onChange    : onFileChange,
        onPreview   : handleIconPreview
    }

    const commentFileProps = {
        fileList    : filelist,
        className   : "commentAttachment2",
        accept      : ".png,.jpeg,.jpg,.pdf",
        multiple    : true,
        beforeUpload: (file) => {
            return false;
        },
        onChange    : onFileChange
    }

    const listProps = {
        loading     : initLoading,
        loadMore    : loadMore,
        itemLayout  : "horizontal",
        dataSource  : newDatasource,
        renderItem  : renderClaimItem
    }

    const chatProps = {
        loading     : chatinitLoading,
        loadMore    : chatLoadMore,
        itemLayout  : "horizontal",
        dataSource  : chatlist,
        renderItem  : chatRenderItem
    }

    const dateprops = {
        style       : { width: "100%" },
        onChange    : onDateChange,
        value       : date,
        disabled    : datedisable,
        picker      : "month"
    }

    const periodprops = {
        style       : {width: "100%"},
        placeholder : "Select period",
        onChange    : onPeriodChange,
        value       : period,
        allowClear  : true,
        disabled    : perioddisable
    }

    //===== SORT TABLE =======
    const onSort    = (table) => {
        table       = table.sort(function (a, b) {
            return (a.updatedte > b.updatedte) ? -1 : 1;
        });

        return table;
    }

    return ( 
        <>
            {(() => {
                if(isMaintenance){
                    return (<T_Error />)
                }
                    else{
                        return (
                            <>
                            {onClaimForm()}
                            {onModal()}
                            {onConfirmationModal()}
                            <Modal
                                visible={previewIconVisible}
                                footer={null}
                                onCancel={handleIconPreviewCancel}
                            >
                                <img alt="" style={{ width: '100%' }} src={previewIconImage} />
                            </Modal>
                        </>   
                        )
                    }
            })()}
        </>
    )
}